/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

import { TransferCustomizationContextValue } from './types';

const noOp = () => {};

export const TransferCustomizationContext =
  createContext<TransferCustomizationContextValue>({
    clearUploadedWallpaper: noOp,
    closeDrawer: noOp,
    isDrawerOpen: false,
    isEnabledForSender: false,
    openDrawer: noOp,
    selectedWallpaperId: null,
    selectWallpaper: noOp,
    wallpapers: [],
    uploadCustomWallpaper: noOp,
    isUploadInProgress: false,
    uploadedWallpaperId: null,
    completedWallpaperAssetIds: new Map(),
    pendingWallpaperIds: new Set(),
    uploadExistingWallpaper: noOp,
  });
